import React from 'react';

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';

export function ConfirmationDialog(props) {
  const { children, content, open, onClose, title = 'Confirmation' } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      aria-labelledby="form-dialog-title"
      fullWidth={true}
      maxWidth="xs"
      onClose={handleClose}
      open={open}
    >
      <DialogTitle id="form-dialog-title">{title}</DialogTitle>

      <DialogContent>
        <span style={{ whiteSpace: 'pre-line' }}>{content}</span>
      </DialogContent>

      <DialogActions>
        {children}
      </DialogActions>
    </Dialog>
  );
}
